import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

const COMPANY_ID = import.meta.env.VITE_WIDGET_COMPANY_ID;
const TOKEN = import.meta.env.VITE_WIDGET_TOKEN;

export const StockTickerWidget = () => {
  const ref = useRef<HTMLDivElement>(null);
  const { i18n } = useTranslation();
  const lang = i18n.language === 'ar' ? 'ar' : 'en';

  useEffect(() => {
    const tryLoad = () => {
      if (ref.current && (window as any).loadWidget) {
        ref.current.innerHTML = '';
        const inner = document.createElement('div');
        inner.id = 'stock-ticker-widget';
        inner.style.width = '100%';
        inner.style.minWidth = '100%';
        ref.current.appendChild(inner);
        (window as any).loadWidget('stock-ticker', COMPANY_ID, lang, TOKEN, 'v2');
      }
    };

    const interval = setInterval(() => {
      if ((window as any).loadWidget) {
        clearInterval(interval);
        tryLoad();
      }
    }, 200);

    tryLoad();

    return () => clearInterval(interval);
  }, [lang]);

  return (
    <div className="relative w-full bg-background h-[var(--ticker-h)] overflow-hidden">
      <div
        ref={ref}
        className="w-full [&_*]:!w-full [&_*]:!min-w-full [&_iframe]:!border-none [&_iframe]:!block [&_iframe]:!h-[80px] [&_iframe]:!min-h-[80px] [&_iframe]:!mt-0 [&_iframe]:invert [&_iframe]:hue-rotate-180"
      />
    </div>
  );
};
